import { render, staticRenderFns } from "./InfoChild.vue?vue&type=template&id=6783a628&lang=pug&"
import script from "./InfoChild.vue?vue&type=script&lang=js&"
export * from "./InfoChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports